import { MDBDataTable } from "mdbreact";
import React, { useEffect, useState } from "react";
import { Badge, Button, Card, Col, Container, Row } from "react-bootstrap";
import "./GroupPermissionsComponent.css";
import "react-checkbox-tree/lib/react-checkbox-tree.css";
import CheckboxTree from "react-checkbox-tree";
import pagesActions from "../../pages/pagesActions";
import { Actions } from "../../../client/Actions";
import { useTranslation } from 'react-i18next';


const GroupPermissionsComponent = () => {

  const { t } = useTranslation();
  const [roles, setRoles] = useState([]);


  const prepareRequest = () => {

    Actions.get("permissions", setRoles);
  };

  useEffect(prepareRequest, []);

  const nodes = [
    {
      value: "MAIN_PANEL",
      label: t("permissions.main_panel"),
      children: [
        { value: "MAIN_PANEL_READ", label: t("permissions.view_no_alarm_status_change") },
        { value: "MAIN_PANEL_ALARM_STATUS_CHANGE", label: t("permissions.alarm_status_change") }
      ]
    },
    {
      value: "PACKAGING_LINES",
      label: t("permissions.packing_lines"),
      children: [
        { value: "PACKAGING_LINES_VIEW", label: t("permissions.view") },
        { value: "PACKAGING_LINES_FULL_ACCESS", label: t("permissions.full_access") }
      ]
    },
    {
      value: "FORMATS",
      label: t("menu.formats"),
      children: [
        { value: "FORMATS_VIEW", label: t("permissions.view_no_edit") },
        { value: "FORMATS_FULL_ACCESS", label: t("permissions.full_access") }
      ]
    },
    {
      value: "FORMATS_WITHDRAWN",
      label: t("menu.formats_withdrawn"),
      children: [
        { value: "FORMATS_WITHDRAWN", label: t("menu.formats_withdrawn") }
      ]
    },
    {
      value: "FONT_MANAGEMENT",
      label: t("permissions.font_management"),
      children: [
        { value: "FONT_MANAGEMENT_VIEW", label: t("permissions.view") },
        { value: "FONT_MANAGEMENT_FULL_ACCESS", label: t("permissions.full_access") }
      ]
    },
    {
      value: "FAST_ACTING_PART",
      label: t("permissions.fast_acting_parts"),
      children: [
        { value: "FAST_ACTING_PART_VIEW", label: t("permissions.view") },
        { value: "FAST_ACTING_PART_FULL_ACCESS", label: t("permissions.full_access") }
      ]
    },
    {
      value: "PRODUCTION",
      label: t("menu.production"),
      children: [
        { value: "PRODUCTION_VIEW", label: t("permissions.view") },
        { value: "PRODUCTION_FULL_ACCESS", label: t("permissions.full_access") }
      ]
    },
    {
      value: "STORAGE_PLACE",
      label: t("menu.storage_place"),
      children: [
        { value: "STORAGE_PLACE_VIEW", label: t("permissions.view_review") },
        { value: "STORAGE_PLACE_FULL_ACCESS", label: t("permissions.full_access") }
      ]
    },
    {
      value: "ADMIN_PANEL",
      label: t("permissions.admin_panel"),
      children: [
        { value: "ADMIN_PANEL_VIEW", label: t("permissions.view") },
        { value: "ADMIN_PANEL_FULL_ACCESS", label: t("permissions.full_access") }
      ]
    }
  ];



  const [selectedRole, setSelectedRole] = useState();

  function isRoleSelected(role) {
    return selectedRole && role.id == (selectedRole ? selectedRole.id : -1);
  }

  function isRoleSelected(role) {
    return selectedRole && role.id == (selectedRole ? selectedRole.id : -1);
  }

  function selectRole(role) {
    setSelectedRole(role);
    setState({ ...state, expanded: [] });
  }


  function buildActionBtn(role) {
    return <div className={isRoleSelected(role) ? "float-right selected" : "float-right"}>
      <Button disabled={isRoleSelected(role)} onClick={() => selectRole(role)}>Uprawnienia
        ({role.permissions.length})</Button>
    </div>;
  };

  function wrapWithDiv(role, value) {
    return <div className={isRoleSelected(role) ? " selected" : ""}>
      {value}
    </div>;
  };


  useEffect(updateRoles, selectedRole);


  function updateRoles() {
    roles && selectedRole && setRoles(roles.map(role => role.id == selectedRole.id ? selectedRole : role));
  }


  function savePermissions() {
    Actions.put("permissions/" + selectedRole.id, selectedRole.permissions, savePermissionsCallback);

  }

  function savePermissionsCallback() {
    setRoles(roles.map(role => role.id == selectedRole.id ? selectedRole : role));
  }


  const rolesTableData = [...(roles.map((role, i) => ({
    id: i + 1,
    name: wrapWithDiv(role, role.groupName),
    actions: buildActionBtn(role)

  })))];

  const permissionsTableData = [];

  const rolesData = {
    columns: [

      {
        field: "name",
        width: 80
      },
      {
        field: "actions",
        width: 30
      }
    ],
    rows: rolesTableData

  };

  const permissionsData = {
    columns: [

      {
        field: "checked",
        width: 30
      },
      {
        field: "name",
        width: 80
      }
    ],
    rows: permissionsTableData

  };

  const [state, setState] = useState({
    checked: [],
    expanded: []
  });


  return (
    <Container className="mt-3 groups">
      <Row>

        <Col>
          <Card>
            <Card.Header>
              {t("permissions.user_groups")}
            </Card.Header>
            <Card.Body>

              <MDBDataTable
                searching={false}
                searchLabel="Szukaj"
                infoLabel={["Pokazano od", "do", "z", ""]}
                entriesLabel={t("common.show")}
                noRecordsFoundLabel={t("common.none")}
                paginationLabel={["«", "»"]}
                paging={false}
                data={rolesData}
              />
            </Card.Body>
          </Card>
        </Col>
        <Col>
          {selectedRole ?

            <div className="groups">
              <Card>
                <Card.Header>
                  Uprawnienia grupy <Badge variant="primary">{selectedRole.name}</Badge>
                </Card.Header>
                <Card.Body>
                  <CheckboxTree
                    nodes={nodes}
                    checked={selectedRole.permissions}
                    expanded={state.expanded}
                    showNodeIcon={false}
                    onCheck={checked => setSelectedRole({ ...selectedRole, permissions: checked })}
                    onExpand={expanded => setState({ ...state, expanded: expanded })}
                    iconsClass="fa5"
                    showExpandAll
                  />

                </Card.Body>
              </Card>

              <Row className="mt-3">
                <Col>
                  <Button
                    onClick={() => savePermissions()}
                    className="float-right">{t("forms.save")}</Button>
                </Col>
              </Row>
            </div>
            : ""}
        </Col>
      </Row>
    </Container>
  );
};

export default GroupPermissionsComponent;
